import { Button, Card, PageTitle } from "@cheatsheetz/core-ui";
import { FloatingTiles } from "@cheatsheetz/sheetz-core/components/FloatingTiles";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AccountRoutes } from "../routes";

export function EmailSignInSentPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  return (
    <div className="relative flex flex-1 items-center justify-center px-4 py-16">
      <PageTitle title="Check Your Email" />
      <FloatingTiles />
      <Card className="z-10 w-full max-w-sm space-y-6 p-6 text-center">
        <div className="flex justify-center">
          <EnvelopeIcon className="size-16 text-success" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Sign-In Link Sent</h1>
          <p className="mt-2 text-sm text-muted-fg">
            {email ? (
              <>
                We've sent a sign-in link to{" "}
                <span className="font-semibold">{email}</span>.<br />
              </>
            ) : null}
            Please check your inbox and click the link to sign in. The link expires in 15
            minutes.
          </p>
        </div>
        <Button
          intent="primary"
          className="w-full"
          onPress={() => navigate(AccountRoutes.Login)}
        >
          Back to Login
        </Button>
      </Card>
    </div>
  );
}
